// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/recibosLegacy/recibos.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_RECIBOS = [
  {
    id: 'recibo',
    label: 'Recibo',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Recibo',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  {
    id: 'factura',
    label: 'Factura',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Recibo',
  },
  {
    id: 'fecha_emision',
    label: 'Fecha de emisión',
    width: 140,
    sortable: true,
    filter: 'date',
    group: 'Fechas',
    hora: true,
  },
  {
    id: 'fecha_vto',
    label: 'Fecha de vencimiento',
    width: 160,
    sortable: true,
    filter: 'date',
    group: 'Fechas',
    hora: true,
  },
  {
    id: 'vencimiento_aplazado',
    label: 'Vencimiento aplazado',
    width: 160,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
  },
  {
    id: 'fecha_cobro',
    label: 'Fecha de cobro',
    width: 130,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
  },
  {
    id: 'cliente',
    label: 'Cliente',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Cliente',
  },
  { id: 'nombre', label: 'Nombre', width: 220, sortable: true, filter: 'text', group: 'Cliente' },
  {
    id: 'tipo_cliente',
    label: 'Tipo de cliente',
    width: 130,
    sortable: true,
    filter: 'multi',
    group: 'Cliente',
  },
  {
    id: 'forma_de_pago',
    label: 'Forma de pago',
    width: 160,
    sortable: true,
    filter: 'multi',
    group: 'Recibo',
  },
  {
    id: 'concepto',
    label: 'Concepto',
    width: 260,
    sortable: true,
    filter: 'text',
    group: 'Recibo',
  },
  {
    id: 'importe',
    label: 'Importe',
    width: 110,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Recibo',
  },
  { id: 'estado', label: 'Estado', width: 120, sortable: true, filter: 'multi', group: 'Recibo' },
  {
    id: 'facturado',
    label: 'Facturado',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'Recibo',
  },
  {
    id: 'caja',
    label: 'Caja',
    width: 90,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Recibo',
  },
  {
    id: 'centro',
    label: 'Centro',
    width: 190,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Matrícula',
  },
  {
    id: 'referencia',
    label: 'Referencia',
    width: 160,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Recibo',
  },
  {
    id: 'Apellido_Alumno',
    label: 'Apellidos del alumno',
    width: 190,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Matrícula',
  },
  {
    id: 'Nombre_Alumno',
    label: 'Nombre del alumno',
    width: 150,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Matrícula',
  },
  {
    id: 'grupo',
    label: 'Grupo',
    width: 200,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Matrícula',
  },
  {
    id: 'estado_matricula',
    label: 'Estado de matrícula',
    width: 150,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Matrícula',
  },
  {
    id: 'fecha_baja',
    label: 'Fecha de baja',
    width: 130,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
    hora: true,
  },
  {
    id: 'motivo_baja',
    label: 'Motivo de baja',
    width: 200,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Matrícula',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_RECIBOS = 'recibos';
